import {ReactElement} from "react";
import {IUnitType, IUseRevenueWizardState, TMetricFavorable} from "../logic/useRevenueWizard";
import UnitTypeSummaryCard from "./UnitTypeSummaryCard";
import * as css from "../styles/summary-column.module.scss";
import {Button} from "@zendeskgarden/react-buttons";
import {Check} from "@material-ui/icons";
import {BiCircle} from "react-icons/bi";
import {VersionType} from "../../../__generated__/generated_types";


interface ISummaryColumnProps {
    metricFavorPreview: TMetricFavorable;
    showAllUnitTypes: boolean;
    revenueWizardInstance: IUseRevenueWizardState;
    previewingVersionType: VersionType;
    convertedUnitTypeData: {unitTypes: IUnitType[], summary: IUnitType | null};
}

export default function SummaryColumn({metricFavorPreview: metricToFavor, showAllUnitTypes, revenueWizardInstance, previewingVersionType, convertedUnitTypeData}: ISummaryColumnProps): ReactElement {
    const {
        selectedMetricToFavor,
        setSelectedMetricToFavor,
    } = revenueWizardInstance;

    const scenarioLabel = metricToFavor == "renewals" ? "A" : "B";
    const titleLabel = metricToFavor == "renewals" ? "Renewals" : "Occupancy";
    const isActive = metricToFavor == selectedMetricToFavor;

    if (!convertedUnitTypeData.summary) {
        return <></>;
    }

    return (
        <div className={css.summaryColumn}>
            <Button className={css.header} isBasic onClick={(() => setSelectedMetricToFavor(metricToFavor))} aria-label={`use values favoring ${metricToFavor}`}>
                <div className={`${css.headerIcon} ${isActive && css.isActive}`}>
                    {metricToFavor == selectedMetricToFavor ?
                        <Check />
                        : <BiCircle />
                    }
                </div>
                <div className={`${css.headerText} ${isActive && css.isActive}`}>
                    <h5 className={css.scenarioText}>Use Scenario {scenarioLabel}</h5>
                    <h4><span style={{fontWeight: 400}}>{previewingVersionType == VersionType.Reforecast ? "Reforecast" : "Budget"} Summary:</span> Favor {titleLabel}</h4>
                </div>
            </Button>
            <div className={css.unitList}>
                <UnitTypeSummaryCard
                    isSummaryUnit={true}
                    metricToFavor={metricToFavor}
                    unitType={convertedUnitTypeData.summary}
                    revenueWizardInstance={revenueWizardInstance}
                    previewingVersionType={previewingVersionType}
                />

                {!showAllUnitTypes &&
                    <div className={css.unitList}>
                        <div className={css.placeholderUnitBox}></div>
                        <div className={`${css.placeholderUnitBox} ${css.lighterBox}`}></div>
                        <div className={`${css.placeholderUnitBox} ${css.lightestBox}`}></div>
                    </div>
                }

                <div className={`${css.unitDetailsList} ${showAllUnitTypes && css.isVisible}`}>
                    {convertedUnitTypeData.unitTypes.map(ut =>
                        <UnitTypeSummaryCard
                            key={ut.name}
                            isSummaryUnit={false}
                            metricToFavor={metricToFavor}
                            unitType={ut}
                            revenueWizardInstance={revenueWizardInstance}
                            previewingVersionType={previewingVersionType}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
